import { userQueryKeys } from '@/config/queryKeys';
import { apiClient } from '@/lib/api-client';
import { ROLE_HIERARCHY } from '@/lib/roles';
import type { UserPublic, UserStudyPublic } from '@/types';
import { useQuery } from '@tanstack/react-query';

/** Infer primary org as first key in allowed_roles.
 * TODO: use primary_org_id from API when available */
export function inferPrimaryOrgId(user: UserPublic): string | undefined {
  return Object.keys(user.allowed_roles ?? {})[0];
}

/** Infer primary role as highest in ROLE_HIERARCHY within the primary org.
 * TODO: use primary_role from API when available */
export function inferPrimaryRole(user: UserPublic, orgId: string): string | undefined {
  const roles = user.allowed_roles?.[orgId] ?? [];
  return ROLE_HIERARCHY.find(r => roles.includes(r));
}

export function useUserDetail(userId: string) {
  return useQuery<UserPublic | null>({
    queryKey: userQueryKeys.detail(userId),
    queryFn: () => apiClient.get<UserPublic>(userQueryKeys.endpoints.detail(userId)),
    staleTime: 5 * 60 * 1000,
  });
}

/** Fetch the studies a user has access to. */
export function useUserStudies(userId: string) {
  return useQuery<UserStudyPublic[]>({
    queryKey: userQueryKeys.studies(userId),
    queryFn: async (): Promise<UserStudyPublic[]> => {
      const studies = await apiClient.get<UserStudyPublic[]>(userQueryKeys.endpoints.studies(userId));
      return studies ?? [];
    },
    staleTime: 5 * 60 * 1000,
  });
}
